module.exports = __webpack_public_path__ + "img/guotai.4c9200b2.webp";